// DateDisplay.tsx

import React from 'react';
import { formatDistanceToNow } from 'date-fns';
import './date-display.scss';

interface DateDisplayAtomProps {
  date: Date | null;
  dateFormat?: string;
  isFriendly?: boolean;
}

const DateDisplay: React.FC<DateDisplayAtomProps> = ({
  date,
  dateFormat,
  isFriendly = false,
}) => {
  // Fallback to user locale if no explicit format is given
  const fallbackFormat = dateFormat ?? navigator.language ?? 'en-US';

  // Convert the date into a displayable string or use placeholder when null
  let formattedDate;

  if (date) {
    if (isFriendly) {
      formattedDate = formatDistanceToNow(date, { addSuffix: true });
    } else {
      formattedDate = new Intl.DateTimeFormat(fallbackFormat, {
        dateStyle: 'medium',
      }).format(date);
    }
  } else {
    formattedDate = '\u00A0'; // Non-breaking space or 'Select a date'
  }

  return <span className="date-display">{formattedDate}</span>;
};

export default DateDisplay;
